import React, { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';

const ChartEmpty: React.FC<any> = (props) => {
  const { t } = useTranslation();

  const mergeStyles = (source: CSSProperties, target?: CSSProperties) => {
    return { ...source, ...(target || {}) };
  };

  return (
    <>
      <div
        style={mergeStyles(
          {
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: 'calc(100% - 36px)',
          },
          {}
        )}
      >
        <>{t('common.noData')}</>
      </div>
    </>
  );
};

export default ChartEmpty;
